import { render } from "./cc-visa-icon.svg?vue&type=template&id=c746a17e"
import script from "./cc-visa-icon.svg?vue&type=script&lang=js"
export * from "./cc-visa-icon.svg?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3480/src/s3/00/src/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__